<h3>Person</h3>
@if (person) {
    <p>
        Adding existing person <strong>{{ person.fullName }}</strong> as a coach.
    </p>
}
@if (temporaryPerson) {
    <div>
        Adding a new person as a coach.
        @if (!createdOrganisation && !joinOrganisation) {
            There are no organisations selected for this coach so
            <b>the welcome email will not be sent.</b>
            They will not be able to login until they are invited to an organisation.
        }
        <div class="row my-1">
            <div class="col-12 col-md-2">First Name:</div>
            <div class="col-12 col-md-10">
                {{ (person || temporaryPerson)!.firstName }}
            </div>
        </div>
        <div class="row mb-1">
            <div class="col-12 col-md-2">Surname:</div>
            <div class="col-12 col-md-10">
                {{ (person || temporaryPerson)!.lastName }}
            </div>
        </div>
        @if (temporaryPerson) {
            <div class="row mb-1">
                <div class="col-12 col-md-2">Email:</div>
                <div class="col-12 col-md-10">{{ temporaryPerson.email }}</div>
            </div>
        }
    </div>
}

<h3 class="mt-3">Coach Details</h3>
<div class="row mb-1">
    <div class="col-12 col-md-2">Start Date:</div>
    <div class="col-12 col-md-10">{{ practitioner.startDate | adaptDate }}</div>
</div>
@if (practitioner.endDate) {
    <div class="row mb-1">
        <div class="col-12 col-md-2">End Date:</div>
        <div class="col-12 col-md-10">
            {{ practitioner.endDate | adaptDate }}
        </div>
    </div>
}
@if (practitioner.notes) {
    <div class="row mb-1">
        <div class="col-12 col-md-2">Notes:</div>
        <div class="col-12 col-md-10"
             [froalaView]="practitioner.notes"></div>
    </div>
}
@if (practitioner.partner) {
    <div class="row mb-1">
        <div class="col-12 col-md-2">Strategic Partner:</div>
        <div class="col-12 col-md-10">{{ practitioner.partner.name }}</div>
    </div>
}

<h3 class="mt-3">Sandbox Organisations</h3>
@if (!joinOrganisation && !createdOrganisation) {
    <div>
        No organisations selected for the new coach.
        @if (temporaryPerson) {
            <b>Welcome email will not be sent.</b>
        }
    </div>
}
@if (createdOrganisation) {
    <div>
        Creating new sandbox organisation <b>{{ createdOrganisation.name }}</b>, and joining as an <b>Employee</b> with the following roles:
        <b>Organisation Leader</b>, <b>Adapt Administrator</b>.
    </div>
}
@if (joinOrganisation) {
    <div>
        Joining existing sandbox organisation
        <b>{{ joinOrganisation.name }}</b> as a <b>Coach</b> ({{ coachRoles }}).
    </div>
}
